// Every date a member reads or picks here is a calendar day on the Auraria
// Campus, so formatting and day arithmetic pin America/Denver rather than the
// browser's zone. The server judges a pickup deadline in the same zone, which
// is what lets the date input's bounds and the server's agree.
export const TIME_ZONE = 'America/Denver';

function toDate(value) {
    // new Date(null) is the epoch, which would render as 1969.
    if (value === null || value === undefined || value === '') {
        return null;
    }
    const date = value instanceof Date ? value : new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
}

/**
 * The Denver calendar day `offsetDays` after the day containing `date`, as
 * YYYY-MM-DD, which is the value format of a date input.
 */
export function denverDateString(date = new Date(), offsetDays = 0) {
    const parts = new Intl.DateTimeFormat('en-US', {
        timeZone: TIME_ZONE,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    }).formatToParts(date);
    const get = (type) => Number(parts.find((p) => p.type === type).value);
    const shifted = new Date(
        Date.UTC(get('year'), get('month') - 1, get('day') + offsetDays)
    );
    return shifted.toISOString().slice(0, 10);
}

/** "Oct 9, 2026", or an empty string for a missing or unparseable value. */
export function formatDenverDate(value) {
    const date = toDate(value);
    if (!date) {
        return '';
    }
    return date.toLocaleDateString('en-US', {
        timeZone: TIME_ZONE,
        dateStyle: 'medium',
    });
}

/** "Oct 9, 2026, 3:42 PM MDT", or an empty string for a bad value. */
export function formatDenverDateTime(value) {
    const date = toDate(value);
    if (!date) {
        return '';
    }
    return date.toLocaleString('en-US', {
        timeZone: TIME_ZONE,
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        timeZoneName: 'short',
    });
}
